// extracted by mini-css-extract-plugin
export default {"Pages":"Pages_Pages__1dcS-","grid":"Pages_grid__0zaug"};